module.exports = __webpack_public_path__ + "static/media/trash.f02d73cb.svg";